import CancelIcon from "@mui/icons-material/Cancel";
import { Divider, Paper } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";

function TicketsInfoModal({ openModal, handleCloseModal, selectedTicket }) {
  const {
    NumeroOS,
    Oficina,
    Tipo,
    TipoDeManutencao,
    SituacaoDaOS,
    ComplexidadeDaOS,
    NumeroDeSerie,
    Equipamento,
    Modelo,
    Abertura,
    Fechamento,
    Ocorrencia,
    Causa,
    Pendencia,
    PendenciaAbertaEm,
    Servico,
    NumeroDaRequisicao,
  } = selectedTicket || {};

  const ticketDetails = [
    { label: "Oficina", value: Oficina },
    { label: "Tipo", value: Tipo },
    {
      label: "Tipo de Manutenção",
      value: TipoDeManutencao,
    },
    {
      label: "Situação da OS",
      value: SituacaoDaOS,
    },
    {
      label: "Complexidade da OS",
      value: ComplexidadeDaOS,
    },
    {
      label: "Número de Série",
      value: NumeroDeSerie,
    },
    { label: "Equipamento", value: Equipamento },
    { label: "Modelo", value: Modelo },
    { label: "Abertura", value: Abertura },
    { label: "Fechamento", value: Fechamento },
    { label: "Ocorrência", value: Ocorrencia },
    { label: "Causa", value: Causa },
    { label: "Pendência", value: Pendencia },
    {
      label: "Pendência Aberta Em",
      value: PendenciaAbertaEm,
    },
    { label: "Serviço", value: Servico },
    {
      label: "Número da Requisição",
      value: NumeroDaRequisicao,
    },
  ];

  return (
    <Modal open={openModal} onClose={handleCloseModal}>
      <Box
        sx={{
          transform: "translate(-50%, -50%)",
        }}
        position="absolute"
        top="50%"
        left="50%"
        bgcolor={(theme) => theme.palette.background}
        boxShadow={24}
        padding={0}
        p={0}
        borderRadius={3}
        width={{ xs: "95vw", sm: 500, md: 650 }}
        minWidth={{ xs: "unset", sm: 400, md: 650 }}
        maxWidth={{ xs: "95vw", sm: 600, md: 650 }}
        maxHeight={{ xs: "95vh", sm: "90vh" }}
        overflow={{ xs: "auto", sm: "hidden" }}
      >
        {selectedTicket && (
          <Paper sx={{ p: { xs: 2, sm: 3 }, borderRadius: 3 }}>
            <Box display="flex" justifyContent="flex-end">
              <CancelIcon
                onClick={handleCloseModal}
                sx={{
                  color: "grey.500",
                  "&:hover": { color: "grey.700" },
                }}
                cursor="pointer"
                fontSize="large"
              />
            </Box>
            <Typography variant="h6" fontSize={{ xs: 18, sm: 22 }}>
              Detalhes da OS: {NumeroOS}
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Box
              display="flex"
              flexWrap="wrap"
              gap={2}
              flexDirection={{ xs: "column", sm: "row" }}
            >
              {ticketDetails.map((item) => (
                <Box key={item.label} flex={"1 1 45%"} minWidth={220}>
                  <Typography variant="caption" color="text.secondary" fontWeight={500}>
                    {item.label}
                  </Typography>
                  <Typography
                    variant="body2"
                    marginBottom={1}
                    color="text.primary"
                    fontWeight={400}
                  >
                    {item.value || "-"}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Paper>
        )}
      </Box>
    </Modal>
  );
}

export default TicketsInfoModal;
